"use strict";

exports.__esModule = true;
exports.getDurationText = exports.getDurationFromMinutes = exports.formatDuration = exports.MINUTES_IN_HOUR = exports.MINUTES_IN_DAY = void 0;
var _dateAndTime = require("../dateAndTime/dateAndTime");
const MINUTES_IN_DAY = exports.MINUTES_IN_DAY = 1440;
const MINUTES_IN_HOUR = exports.MINUTES_IN_HOUR = 60;
const getDurationUnitKeys = durationAria => {
  return {
    hourUnit: durationAria ? 'duration.units.aria-hours' : 'duration.units.hours',
    minuteUnit: durationAria ? 'duration.units.aria-minutes' : 'duration.units.minutes',
    dayUnit: durationAria ? 'duration.units.aria-days' : 'duration.units.days'
  };
};
const trimAriaSingularSuffix = ({
  text,
  unitValue,
  durationAria
}) => {
  if (durationAria && unitValue === 1 && text) {
    return text.slice(0, -1);
  }
  return text;
};
const splitMinutesToDaysHoursMinutes = totalMinutes => {
  const days = Math.floor(totalMinutes / MINUTES_IN_DAY);
  const remainingMinutes = totalMinutes % MINUTES_IN_DAY;
  const hours = Math.floor(remainingMinutes / MINUTES_IN_HOUR);
  const minutes = remainingMinutes % MINUTES_IN_HOUR;
  return {
    days,
    hours,
    minutes
  };
};
const splitMinutesToHoursMinutes = totalMinutes => {
  const hours = Math.floor(totalMinutes / MINUTES_IN_HOUR);
  const minutes = totalMinutes % MINUTES_IN_HOUR;
  return {
    hours,
    minutes
  };
};
const formatDayAwareDuration = ({
  totalMinutes,
  t,
  durationAria
}) => {
  const {
    dayUnit,
    hourUnit,
    minuteUnit
  } = getDurationUnitKeys(durationAria);
  const {
    days,
    hours,
    minutes
  } = splitMinutesToDaysHoursMinutes(totalMinutes);
  const dayText = trimAriaSingularSuffix({
    text: t(dayUnit, {
      days
    }),
    unitValue: days,
    durationAria
  });
  const hourText = hours ? trimAriaSingularSuffix({
    text: t(hourUnit, {
      hours
    }),
    unitValue: hours,
    durationAria
  }) : '';
  const minuteText = minutes ? t(minuteUnit, {
    minutes
  }) : '';
  return [dayText, hourText, minuteText].filter(Boolean).join(' ');
};
const formatHourMinuteDuration = ({
  totalMinutes,
  t,
  durationAria
}) => {
  const {
    hourUnit,
    minuteUnit
  } = getDurationUnitKeys(durationAria);
  const {
    hours,
    minutes
  } = splitMinutesToHoursMinutes(totalMinutes);
  const hourText = trimAriaSingularSuffix({
    text: t(hourUnit, {
      hours
    }),
    unitValue: hours,
    durationAria
  });
  const minuteText = t(minuteUnit, {
    minutes
  });
  return hours ? hourText + (minutes ? ` ${minuteText}` : '') : minuteText;
};
const formatDuration = (totalMinutes, t, durationAria, enableDayUnits = false) => {
  if (enableDayUnits && totalMinutes >= MINUTES_IN_DAY) {
    return formatDayAwareDuration({
      totalMinutes,
      t,
      durationAria
    });
  }
  return formatHourMinuteDuration({
    totalMinutes,
    t,
    durationAria
  });
};
exports.formatDuration = formatDuration;
const getDurationText = ({
  rfcStartTime,
  rfcEndTime,
  t,
  enableDayUnits = false
}) => {
  const durationInMinutes = (0, _dateAndTime.differencesBetweenTwoDates)(rfcStartTime, rfcEndTime, _dateAndTime.TimeUnits.minute);
  return getDurationFromMinutes({
    minutes: durationInMinutes,
    t,
    enableDayUnits
  });
};
exports.getDurationText = getDurationText;
const getDurationFromMinutes = ({
  minutes,
  t,
  enableDayUnits = false
}) => {
  return {
    durationText: formatDuration(minutes, t, false, enableDayUnits),
    durationAriaText: formatDuration(minutes, t, true, enableDayUnits)
  };
};
exports.getDurationFromMinutes = getDurationFromMinutes;
//# sourceMappingURL=duration.js.map